import React from "react";
import BillingDateField from "./BillingDateField";
import BillingField from "./BillingField";
import BillingTextField from "./BillingTextField";
import { IBillingValues, SelectItem } from "../types/locationTypes";
import { Checkbox, FormControlLabel, Select, MenuItem, TextField } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import api from '../../../store/api';
import { useForm, Controller } from "react-hook-form"; interface CommonRowProps {
  billingValuesObj: IBillingValues;
  handleSetBillingValuesObj: any;
  disabled: boolean;
  parentClasses: ClassNameMap;
  retainerIntervals: SelectItem[];
}
const useStyles = makeStyles((theme) => ({
  textFieldLable: {
    fontSize: 15,
    color: '#949494',
    padding: theme.spacing(0, 0, 1, 0)
  },
  textFieldRoot: {
    width: '100%'
  },
  formBtn: {
    margin: theme.spacing(0, 1, 0, 1),
    width: '100px',
    height: '40px'
  },
}));
const CommonRow: React.FC<CommonRowProps> = ({ billingValuesObj, handleSetBillingValuesObj, disabled, parentClasses, retainerIntervals }) => {
  const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
  const classes = useStyles();
  return (
    <>
      <div className={parentClasses.row}>
        <BillingDateField
          title="COMMENCEMENT DATE"
          description="Date the fees above came into effect"
          parentClasses={parentClasses}
          disabled={disabled}
          value={billingValuesObj.commencementDate}
          setValue={(newValue: string | null) => handleSetBillingValuesObj("commencementDate", newValue)}
        />
        <BillingField
          title="ANNUAL INCREASE (%)"
          description="Annual inflation increase, eg 2%"
          parentClasses={parentClasses}
          disabled={disabled}
          value={billingValuesObj.annualInflationIncrease}
          setValue={(newValue: string | null) => handleSetBillingValuesObj("annualInflationIncrease", newValue)}
        />
      </div>
      <div>
        <hr className={parentClasses.separator} />
      </div>
      <div className={parentClasses.flexContainer} style={{ paddingLeft: 10 }}>
        <FormControlLabel
          control={
            <Checkbox
              style={{ padding: 4 }}
              disableRipple
              disabled={disabled}
              checked={billingValuesObj.hasRetainer === true}
              onChange={(e: React.ChangeEvent<any>) => {
                handleSetBillingValuesObj("hasRetainer", e.target.checked);
              }}
            />
          }
          label="Customer has a retainer that includes free transfers"
        />
        <div className={parentClasses.row} style={{ paddingLeft: 30 }}>
          <div>
            <div className={parentClasses.formControlLabel}>RETAINER INTERVAL</div>
            <div style={{ width: 230, margin: "10px 0px" }}>
              <Select
                onChange={(e) => {
                  handleSetBillingValuesObj("retainerInterval", e.target.value);
                }}
                fullWidth={true}
                value={billingValuesObj.retainerInterval}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                defaultValue=""
                variant="outlined"
              >
                {retainerIntervals.map((item) => (
                  <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          <BillingField
            title="TRANSFERS INCLUDED"
            description=""
            parentClasses={parentClasses}
            disabled={disabled}
            value={billingValuesObj.retainerTransfersNum}
            setValue={(newValue: string | null) => {
              if (newValue && newValue !== "") {
                newValue = `${parseInt(newValue)}`;
              }
              handleSetBillingValuesObj("retainerTransfersNum", newValue);
            }}
          />
        </div>
      </div>
      <div>
        <hr className={parentClasses.separator} />
      </div>
      <div className={parentClasses.flexContainer} style={{ paddingLeft: 10 }}>
        <FormControlLabel
          control={
            <Checkbox
              style={{ padding: 4 }}
              disableRipple
              disabled={disabled}
              checked={billingValuesObj.transferFeesDoubled === true}
              onChange={(e: React.ChangeEvent<any>) => {
                handleSetBillingValuesObj("transferFeesDoubled", e.target.checked);
              }}
            />
          }
          label="Transfer fee is doubled if either or both of the following apply"
        />
        <div className={parentClasses.row} style={{ paddingLeft: 30, gap: 0 }}>
          <BillingField
            title="DISTANCE OVER... (KM)"
            description=""
            parentClasses={parentClasses}
            disabled={disabled}
            value={billingValuesObj.maxDistancePerTransfer}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("maxDistancePerTransfer", newValue)}
          />
          <div style={{ width: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <p
              style={{
                fontSize: 14,
                color: "#949494",
                fontWeight: 700,
                marginTop: 42,
              }}
            >
              OR
            </p>
          </div>
          <BillingField
            title="DURATION OVER... (MIN)"
            description=""
            parentClasses={parentClasses}
            disabled={disabled}
            value={billingValuesObj.timeLimitPerTransfer}
            setValue={(newValue: string | null) => {
              if (newValue && newValue !== "") {
                newValue = `${parseInt(newValue)}`;
              }
              handleSetBillingValuesObj("timeLimitPerTransfer", newValue);
            }}
          />
        </div>
      </div>
      <div>
        <hr className={parentClasses.separator} />
      </div>
      <div className={parentClasses.flexContainer} style={{ paddingLeft: 10 }}>
        <FormControlLabel
          control={
            <Checkbox
              style={{ padding: 4 }}
              disableRipple
              disabled={disabled}
              checked={billingValuesObj.addWaitTimeFees === true}
              onChange={(e: React.ChangeEvent<any>) => {
                handleSetBillingValuesObj("addWaitTimeFees", e.target.checked);
              }}
            />
          }
          label="Add an additional fee if wait time is incurred"
        />
        <div className={parentClasses.row} style={{ paddingLeft: 30 }}>
          <BillingField
            title="GRACE PERIOD (MIN)"
            description=""
            parentClasses={parentClasses}
            disabled={disabled}
            value={billingValuesObj.waitTimeGracePeriod}
            setValue={(newValue: string | null) => {
              if (newValue && newValue !== "") {
                newValue = `${parseInt(newValue)}`;
              }
              handleSetBillingValuesObj("waitTimeGracePeriod", newValue);
            }}
          />
          <BillingField
            title="RATE PER HOUR ($)"
            description=""
            parentClasses={parentClasses}
            disabled={disabled}
            value={billingValuesObj.waitTimeRatePerHour}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("waitTimeRatePerHour", newValue)}
          />
        </div>
      </div>
    </>
  );
};

export default CommonRow;
